
require.register("dagre/lib/version.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "dagre");
  (function() {
    module.exports = "0.8.4";
  })();
});